<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.grades', 2),
                        href: route('students.grades.index', {
                            trimester: selectedTrimester,
                        }),
                    },
                    {
                        name: category.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-3 flex space-x-2">
            <div v-for="trimester in [1, 2, 3]" :key="trimester">
                <AppButton
                    element="InertiaLink"
                    :desired-action="trimester == selectedTrimester"
                    :href="`?trimester=${trimester}`"
                >
                    {{ $t('messages.trimester') }} {{ trimester }}
                </AppButton>
            </div>
        </div>

        <div>
            <apexchart :type="gradesChart.chart.type" height="350" :series="gradesChart.series" :options="gradesChart">
            </apexchart>
        </div>

        <div>
            <ul>
                <li v-for="dimension in category.dimensions" :key="dimension.id">
                    {{ dimension.abbreviation }} - {{ dimension.title }}
                </li>
            </ul>
        </div>

        <!--        <div class="mt-3">-->
        <!--            @foreach($legendPills as $name => [$bgClass, $textClass])-->
        <!--            <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium {{ $bgClass }} {{ $textClass }}">-->
        <!--          {{ $name }}-->
        <!--        </span>-->
        <!--            @endforeach-->
        <!--        </div>-->
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: { AppButton, PanelPage },
    layout: Layout,
    name: 'Show',
    props: ['gradesChart', 'category', 'legendPills', 'selectedTrimester'],
    data() {
        return {};
    },
    computed: {
        filteredForm: function () {
            return [];
        },
    },
    methods: {
        getParams() {
            return [];
        },
    },
};
</script>
